<script setup lang="ts">
const attrs = useAttrs()

const currentComponent = attrs.media
  ? resolveComponent('HeroPanelStandard')
  : resolveComponent('HeroPanelStandardContentOnly')
</script>

<template>
  <component :is="currentComponent" v-bind="{ ...$props, ...$attrs }" />
</template>
